import { ReactNode } from 'react'
import { Radio } from 'antd'

interface Props {
  value: string | number
  checked: boolean
  icon: ReactNode
  label: string
}

export default function CustomRadioCard({
  value,
  checked,
  icon,
  label
}: Props) {
  return (
    <Radio value={value} className="flex flex-col-reverse px-12">
      <div
        className={`flex flex-col items-center p-1 rounded-lg cursor-pointer border transition
          ${
            checked
              ? 'border-blue-500'
              : 'border-transparent hover:border-gray-300'
          }`}
      >
        <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center mb-2">
          {icon}
        </div>
        <div className="text-sm font-bold mb-2 text-center">{label}</div>
      </div>
    </Radio>
  )
}
